import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeature } from '../context/FeatureContext';

// Route-guard: rendert children alleen als de feature aanstaat voor deze school,
// anders redirect naar het dashboard. Menu verbergen alleen is niet genoeg tegen
// directe URL-toegang — daarom ook hier gaten.
export default function FeatureRoute({ feature, children }) {
  const enabled = useFeature(feature);
  if (!enabled) return <Navigate to="/dashboard-new" replace />;
  return children;
}
